import design, { remCalc } from '@/config/design';
export const GRID = {
  colWidth: 100,
  rowHeight: 40,
  smallRowHeight: 32,
  rowHeaderWidth: 40
};
export const HEADER_STYLES = {
  textTransform: 'uppercase',
  fontSize: remCalc(11),
  fontWeight: 700,
  color: design.colors.gray60,
  backgroundColor: design.colors.gray10,
  outline: `1px solid ${design.colors.gray30}`
};
export const DISABLED_STYLES = {
  backgroundColor: design.colors.gray5
};
export const DEFAULT_COLUMN_STRUCTURE = {
  labelColumn: 'Labels',
  subColumns: [{
    label: 'Column'
  }],
  repeatSubColumns: true
};